export function truncateAddress(address)  {
    // console.log(address)
    return address.slice(0,5) + "..." + address.slice(-3);
}